import React from 'react';
import {Link} from 'react-router-dom';
import {withRouter} from 'react-router';
import {useTranslation} from 'react-i18next';
import * as R from 'ramda';
import {availableLocales, localizePath} from '@/i18n';

const LangMenu = ({location}) => {
  const to = localizePath(location);
  const {t: tr, i18n} = useTranslation();
  const currentLang = i18n.language;

  return (
    <li className='menu'>
      <Link to={to(currentLang)}>
        {tr(`language.${currentLang}`)}
        <i className='material-icons'>keyboard_arrow_down</i>
      </Link>

      <ul>
        {R.compose(
          R.map(lang => (
            <li key={lang}>
              <Link to={to(lang)}>{tr(`language.${lang}`)}</Link>
            </li>
          )),
          R.difference(availableLocales)
        )([currentLang])}
      </ul>
    </li>
  );
};

export default withRouter(LangMenu);
